import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useRef, useState } from 'react';
import Dialog from 'components/dialog/dialog';
import SvgMenu from 'components/svgs/menu';
import { sendTrackingEventsOnClick } from 'helpers/productPrice/subscriptions';
import MobileMenu from '../mobileMenu/mobileMenu';
import VeggieBurgerButton from '../veggieBurgerButton/veggieBurgerButton';
import { mobileMenuContainer } from './mobileMenuTogglerStyles';
export default function MobileMenuToggler({ utility, links, }) {
    const [menuOpen, setMenuOpen] = useState(false);
    const [buttonPosition, setButtonPosition] = useState(undefined);
    const buttonRef = useRef(null);
    return (_jsxs("div", { css: mobileMenuContainer, children: [_jsx(VeggieBurgerButton, { ref: buttonRef, "aria-haspopup": "dialog", "aria-label": "menu", onClick: () => {
                    setMenuOpen(true);
                    sendTrackingEventsOnClick({
                        id: 'open_mobile_menu',
                        componentType: 'ACQUISITIONS_BUTTON',
                    })();
                    if (buttonRef.current) {
                        const bounds = buttonRef.current.getBoundingClientRect();
                        setButtonPosition({
                            x: bounds.left + bounds.width / 2,
                            y: bounds.top,
                        });
                    }
                }, children: _jsx(SvgMenu, {}) }), _jsx(Dialog, { "aria-label": "Menu", open: menuOpen, closeDialog: () => {
                    setMenuOpen(false);
                    sendTrackingEventsOnClick({
                        id: 'dismiss_mobile_menu',
                        componentType: 'ACQUISITIONS_BUTTON',
                    })();
                }, children: _jsx(MobileMenu, { closeButtonAt: buttonPosition, utility: utility, links: links, onClose: () => {
                        setMenuOpen(false);
                        sendTrackingEventsOnClick({
                            id: 'close_mobile_menu',
                            componentType: 'ACQUISITIONS_BUTTON',
                        })();
                    } }) })] }));
}
